import { useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
import { useAuth } from "../lib/auth.jsx";

// Fixed banner shown whenever the current session is an admin viewing-as another
// user. Exit restores the original admin session and returns to the admin portal.
export default function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  const navigate = useNavigate();
  if (!user || !user.impersonator) return null;
  const exit = async () => {
    try { await stopImpersonation(); navigate("/admin"); }
    catch (e) { /* leave the session as-is on failure */ }
  };
  return (
    <div className="imp-banner" role="status">
      <Eye size={15} aria-hidden="true" />
      <span className="imp-banner__text">
        Viewing as <strong>{user.email}</strong>
        {user.impersonator.email ? <span className="imp-banner__admin"> - admin {user.impersonator.email}</span> : null}
      </span>
      <button type="button" className="imp-banner__exit" onClick={exit}>Exit view-as</button>
    </div>
  );
}
